import React, { useEffect, useState } from "react";

const KEY = "consent.analytics"; // "granted" | "denied"

export default function ConsentBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) {
      setShow(true);
      return;
    }
    // Re-apply previous choice on load (no banner)
    if (saved === "granted") {
      window.gtag?.('consent', 'update', { analytics_storage: 'granted' });
      window.gtag?.('event', 'page_view', { page_path: window.location.pathname });
    } else {
      window.gtag?.('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
      });
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "granted");
    window.gtag?.('consent', 'update', { analytics_storage: 'granted' });
    window.gtag?.('event', 'page_view', { page_path: window.location.pathname });
    setShow(false);
  };

  const reject = () => {
    localStorage.setItem(KEY, "denied");
    window.gtag?.('consent', 'update', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={barStyle}>
<span>
  Nous utilisons <strong>uniquement</strong> des cookies de
  <strong> mesure d’audience (analytics)</strong>, sans publicité ni profilage.
  Vous pouvez <strong>Refuser</strong> ou <strong>Accepter</strong>.
  Vous pourrez changer d’avis à tout moment dans « Gérer les cookies ».
  <a href="#/privacy" style={{ textDecoration: 'underline', marginLeft: 8 }}>
    En savoir plus
  </a>
</span>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={reject} style={btnGhost}>Reject</button>
        <button onClick={accept} style={btnPrimary}>Accept</button>
      </div>
    </div>
  );
}

const barStyle: React.CSSProperties = {
  position: "fixed",
  left: 0, right: 0, bottom: 0,
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 16px",
  background: "#111827",
  color: "#fff",
  fontSize: 14,
  boxShadow: "0 -2px 10px rgba(0,0,0,.2)"
};

const btnPrimary: React.CSSProperties = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  background: "#3b82f6",
  color: "#fff",
  fontWeight: 600
};

const btnGhost: React.CSSProperties = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #6b7280",
  background: "transparent",
  color: "#e5e7eb",
  cursor: "pointer",
  fontWeight: 600
};
